module.exports = __webpack_public_path__ + "static/img/store-primary.4d5996f0.svg";